import { useEffect, useState } from "react";
import { listAll, subscribe, type QueuedExpense } from "./queue";

// React hook that returns the live list of queued expenses + a
// pending-count for the FAB badge. Re-renders any subscriber when
// the queue changes (enqueue, state transition, removal).
export function useQueuedExpenses(): {
  queued: QueuedExpense[];
  pendingCount: number;
} {
  const [queued, setQueued] = useState<QueuedExpense[]>([]);

  useEffect(() => {
    let cancelled = false;
    async function refresh() {
      const all = await listAll();
      if (!cancelled) setQueued(all);
    }
    refresh();
    const unsub = subscribe(refresh);
    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  // "Pending" excludes the synced state — synced rows fade after a
  // few seconds and aren't user-actionable.
  const pendingCount = queued.filter((q) => q.state !== "synced").length;
  return { queued, pendingCount };
}
